<template>
  <div class="error-handler">
    <BaseText class="error-handler__text" appearance="subtle">
      {{ message }}
    </BaseText>

    <ButtonTertiary
      class="error-handler__button"
      applied-on="normal"
      icon="EA0140"
      iconPosition="right"
      :disabled="disabled || loading"
      :loading="loading"
      :label="buttonLabel"
      @click="handleRetry"
    />
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from 'vue';
import { BaseText, ButtonTertiary } from '@warrenbrasil/nebraska-web';

const props = defineProps({
  message: {
    type: String,
    default: 'Não foi possível carregar todos os serviços.'
  },
  buttonLabel: {
    type: String,
    default: 'Tentar novamente'
  },
  loading: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits<{
  (event: 'retry'): void;
}>();

function handleRetry() {
  if (props.disabled || props.loading) {
    return;
  }
  emit('retry');
}
</script>

<style lang="less" scoped>
.error-handler {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: @size-spacing-x350;
  background-color: #f9f0e6;
  gap: @size-spacing-x400;
  border-radius: 4px;
  margin-top: @size-spacing-x350;
}

.error-handler__text {
  flex: 1;
  margin: 0;
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;

  &,
  :deep(*) {
    color: @status-alert !important;
  }
}

.error-handler__button {
  width: 100%;
  max-width: 180px;

  /* Alvo profundo nas propriedades internas do ButtonTertiary da Nebraska */
  :deep(.button--label),
  :deep(.button-box-launch__label),
  :deep(.button__icon),
  :deep(.icon),
  :deep(svg) {
    color: @status-alert !important;
    fill: @status-alert !important; /* Garante a cor caso o ícone seja injetado como SVG nativo */
  }
}
</style>
